import { Layout, Space, Typography } from "antd";
import React from "react";
import CustomHeader from "../components/common/Header";
const { Title } = Typography;

const Thanks = () => {
  const { Content, Footer } = Layout;
  return (
    <Layout className="bg-white">
      <CustomHeader />
      <Content className="p-4 pb-0 md:p-6">
        <div className="container mx-auto followingl-list text-center md:text-left">
          <Space direction="vertical" className="w-full" size={30}>
            <Title
              level={1}
              className="font-bold text-center md:text-left"
              style={{
                fontSize: "1.5rem"
              }}
            >
              Thank You!
            </Title>
            <Title
              level={3}
              className="!font-normal text-center md:text-left"
              style={{
                fontSize: "0.938rem"
              }}
            >
              Your request has been submitted successfully and a confirmation
              email has been sent to you.{" "}
            </Title>
            <Title
              level={3}
              className="!font-normal !mt-4 md:!mt-8 text-center md:text-left"
              style={{
                fontSize: "0.938rem"
              }}
            >
              If you do not see the confirmation email, please check your spam folder as the email will be coming from <a href="mailto:requests@provider1st.com" className="!underline !text-[#000000e0]">requests@provider1st.com</a>. 
            </Title>
          </Space>

          <Title
            level={3}
            className="mt-10 md:mt-20 text-center !font-semibold md:text-left"
            style={{  fontSize: "0.938rem" }}
          >
          If you need assistance with your request, please give us a call: <a href="tel:855-514-2378"><u>855-514-2378</u></a>.
          </Title>
        </div>
      </Content>
      <Footer className="welcome-footer bg-white">
        <img
          className="m-auto"
          src={window.location.origin + "/assets/images/Logo.svg"}
        />
      </Footer>
    </Layout>
  );
};

export default Thanks;
